export const PILLARS = [["resuscitation", "Resuscitation"], ["haemodynamics", "Haemodynamics"], ["ventilation", "Ventilation"], ["endpoint_monitoring", "End-point monitoring"]];
